import { mapGetters } from 'vuex';
import { TemplateActions } from '../../store/actions';
import { TemplateGetters } from '../../store/getters';
import { Permissions } from '../../enums/permissionsEnum';
import ConfirmDialog from '../../components/core/dialogs/confirmDialog';

export default {
	computed: {
		...mapGetters({
			templates: [TemplateGetters.TEMPLATES],
		}),
		canAddTemplates() {
			return this.hasPermissions([
				Permissions.Tools.DataImport.Templates.Add,
			]);
		},
		canEditTemplates() {
			return this.hasPermissions([
				Permissions.Tools.DataImport.Templates.Edit,
			]);
		},
		canDeleteTemplates() {
			return this.hasPermissions([
				Permissions.Tools.DataImport.Templates.Delete,
			]);
		},
	},
	data() {
		return {
			filteredItems: [],
			showTemplateDialog: false,
			searchTemplates: '',
			selectedTemplate: null,
			selectedTemplateIndex: null,
			editTemplate: null,
		};
	},
	mounted() {
		this.$store.dispatch(TemplateActions.LOAD_TEMPLATES).then(() => {
			if (this.templates.length > 0) {
				this.filteredItems = this.templates;
				this.onSelectTemplate(this.filteredItems[0]);
			}
		});
	},
	methods: {
		onSelectTemplate(item) {
			this.selectedTemplate = item;
			this.loadTemplateFields();
		},

		loadTemplateFields() {
			this.$store.dispatch(TemplateActions.CLEAR_TEMPLATE_FIELDS);
			if (this.selectedTemplate) {
				this.$store.dispatch(
					TemplateActions.LOAD_TEMPLATE_FIELDS,
					this.selectedTemplate.Id
				);
			}
		},

		onClearSearchTemplate() {
			this.onTemplateSearchChanged();
		},
		onTemplateSearchChanged(props) {
			if (!props) {
				this.filteredItems = this.templates;
			} else {
				this.filteredItems = this.templates.filter((x) => {
					return (
						x.Name &&
						x.Name.toLowerCase().includes(props.toLowerCase())
					);
				});
			}
			if (this.filteredItems.length > 0) {
				this.selectedTemplateIndex = 0;
				this.onSelectTemplate(this.filteredItems[0]);
			} else {
				this.selectedTemplateIndex = null;
				this.onSelectTemplate(null);
			}
		},

		addTemplate() {
			this.editTemplate = null;
			this.showTemplateDialog = true;
		},
		closeTemplateDialog() {
			this.editTemplate = null;
			this.onTemplateSearchChanged(this.searchTemplates);
			this.showTemplateDialog = false;
		},

		onEditTemplate(item) {
			this.editTemplate = item;
			this.showTemplateDialog = true;
		},
		onDeleteTemplate(item) {
			ConfirmDialog({
				message: 'Are you sure you want to delete this Template?',
			}).then((isDelete) => {
				if (!isDelete) return;
				this.$store
					.dispatch(TemplateActions.DELETE_TEMPLATE, item.Id)
					.then(() => {
						this.onTemplateSearchChanged(this.searchTemplates);
					});
			});
		},
	},
};
